import { IonCol, IonContent, IonGrid, IonPage, IonRow, IonText } from "@ionic/react";
import LanguagePack from "../../services/translations";

const Profile: React.FC = () => {
    
    const translations = new LanguagePack;
    const strings = translations.getHomeTranslations('en');

    const name = strings.userTitle;

    return (
        <IonPage className="viewContainer">
            <IonContent>
                <IonGrid>
                    <IonRow>
                        <IonCol>
                            <IonText>
                                <h1>{strings.userTitle}</h1>
                            </IonText>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonContent>
        </IonPage>)
}

export default Profile;

